// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app__timeopend_schedule {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px;
}

.app__timeopend_schedule-heading {
  font-size: 4.5rem; /* Größere Schriftgröße für die Überschrift */
  font-family: "SawtonCircular-Medium";
  margin-bottom: 20px; /* Mehr Abstand unter der Überschrift */
}

.app__timeopend_schedule-container {
  display: flex;
  flex-direction: column;
  align-items: center; /* Horizontal zentrieren */
  width: 100%; /* Breite auf 100% setzen */
  max-width: 650px;
}

.app__timeopend_schedule-dayTime {
  display: flex;
  flex-direction: row; /* Horizontale Anordnung von Tagen und Zeiten */
  justify-content: space-between; /* Platz zwischen Tagen und Zeiten */
  width: 100%;
  margin-bottom: 10px; /* Mehr Abstand zwischen den Einträgen */
  font-family: "SawtonIndustrial-Light";
}

.app__timeopend_schedule-day,
.app__timeopend_schedule-time {
  flex: 1 1;
  text-align: center;
  font-size: 2rem;
  text-align: right;
}
.app__timeopend_schedule-day {
  font-weight: bold;
  text-align: left;
}

@media screen and (max-width: 450px) {
  .app__timeopend_schedule-day,
  .app__timeopend_schedule-time {
    font-size: 20px;
  }
  .app__timeopend_schedule-heading {
    font-size: 37px;
  }
  .app__timeopend_schedule {
    padding: 30px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/container/Timeopend/timeOpend.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,iBAAiB,EAAE,6CAA6C;EAChE,oCAAoC;EACpC,mBAAmB,EAAE,uCAAuC;AAC9D;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB,EAAE,0BAA0B;EAC/C,WAAW,EAAE,2BAA2B;EACxC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB,EAAE,+CAA+C;EACpE,8BAA8B,EAAE,oCAAoC;EACpE,WAAW;EACX,mBAAmB,EAAE,wCAAwC;EAC7D,qCAAqC;AACvC;;AAEA;;EAEE,SAAO;EACP,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE;;IAEE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf;AACF","sourcesContent":[".app__timeopend_schedule {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  padding: 40px;\r\n}\r\n\r\n.app__timeopend_schedule-heading {\r\n  font-size: 4.5rem; /* Größere Schriftgröße für die Überschrift */\r\n  font-family: \"SawtonCircular-Medium\";\r\n  margin-bottom: 20px; /* Mehr Abstand unter der Überschrift */\r\n}\r\n\r\n.app__timeopend_schedule-container {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center; /* Horizontal zentrieren */\r\n  width: 100%; /* Breite auf 100% setzen */\r\n  max-width: 650px;\r\n}\r\n\r\n.app__timeopend_schedule-dayTime {\r\n  display: flex;\r\n  flex-direction: row; /* Horizontale Anordnung von Tagen und Zeiten */\r\n  justify-content: space-between; /* Platz zwischen Tagen und Zeiten */\r\n  width: 100%;\r\n  margin-bottom: 10px; /* Mehr Abstand zwischen den Einträgen */\r\n  font-family: \"SawtonIndustrial-Light\";\r\n}\r\n\r\n.app__timeopend_schedule-day,\r\n.app__timeopend_schedule-time {\r\n  flex: 1;\r\n  text-align: center;\r\n  font-size: 2rem;\r\n  text-align: right;\r\n}\r\n.app__timeopend_schedule-day {\r\n  font-weight: bold;\r\n  text-align: left;\r\n}\r\n\r\n@media screen and (max-width: 450px) {\r\n  .app__timeopend_schedule-day,\r\n  .app__timeopend_schedule-time {\r\n    font-size: 20px;\r\n  }\r\n  .app__timeopend_schedule-heading {\r\n    font-size: 37px;\r\n  }\r\n  .app__timeopend_schedule {\r\n    padding: 30px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
